var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "loan-stat__inner" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "loan-stat__value loan-stat__value--loading" },
          [_c("span", { staticClass: "loan-stat__skeleton" })]
        )
      : _vm.repaymentAmount === null
      ? _c("div", { staticClass: "loan-stat__value loan-stat__value--error" }, [
          _vm._v("—"),
        ])
      : _c("div", { staticClass: "loan-stat__value" }, [
          _vm._v("$" + _vm._s(_vm.repaymentAmount.toFixed(2))),
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "loan-stat__desc" }, [
      _vm._v(_vm._s(_vm.frequencyLabel)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "loan-stat__label" }, [
      _vm._v("Repayment Amount (Approx.)"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }